module.exports = __webpack_public_path__ + "static/media/subaru-forrester.1278b9c2.jpg";